import React from 'react';
import { SimplifyJobDetailType } from '@/types/job-detail';
import Autocomplete from '@/components/form/Autocomplete';
import Select, { Option } from '@/components/form/Select';
import JobOpportunityCard from '../JobOpportunityCard';
import { searchCompanyJDJobTitleByQuery, searchCompanyJob } from '@/api/tanzhi';

interface Props {
  show: boolean;
  companyId: string;
}

type jobTitleValueType = {
  id: string;
  name: string;
} | null;

type SearchResultType = {
  count: number;
  locations: Option[];
  jobs: SimplifyJobDetailType[];
};
const HotJobsTabPanel = (props: Props) => {
  const { show, companyId } = props;
  const [jobTitleValue, setJobTitleValue] =
    React.useState<jobTitleValueType>(null);
  const [locationValue, setLocationValue] = React.useState('all');
  const initialSearchResult = {
    count: 0,
    locations: [{ label: '全国', value: 'all' }],
    jobs: [],
  };
  const [searchResult, setSearchResult] =
    React.useState<SearchResultType>(initialSearchResult);
  const cacheRef = React.useRef(new Map());

  const { count, locations, jobs } = searchResult;

  React.useEffect(() => {
    if (!show) return;
    const cacheKey = `${jobTitleValue?.id || 'null'}_${locationValue}`;
    if (cacheRef.current.has(cacheKey)) {
      setSearchResult(cacheRef.current.get(cacheKey));
      return;
    }

    let isMounted = true;
    searchCompanyJob(
      companyId,
      jobTitleValue?.id,
      locationValue === 'all' ? '' : locationValue,
    ).then((response) => {
      if (!isMounted) {
        return;
      }
      const { count, locations, data } = response.data;
      const newLocOptions = locations.map(
        (item: { id: string; name: string }) => ({
          label: item.name,
          value: item.id,
        }),
      );
      const newSearchResult = {
        count,
        locations: [{ label: '全国', value: 'all' }, ...newLocOptions],
        jobs: data,
      };
      setSearchResult(newSearchResult);
      cacheRef.current.set(cacheKey, newSearchResult);
    });
    return () => {
      isMounted = false;
    };
  }, [show, jobTitleValue, locationValue]);

  const handleChangeJobTitle = (value: jobTitleValueType) => {
    setJobTitleValue(value);
  };

  const handleChangeLocationValue = (value: string) => {
    setLocationValue(value);
  };

  return (
    <div hidden={!show} className="relative gap-4 flex flex-col">
      <div className="flex gap-x-7.5">
        <Autocomplete
          searchAtFirstClick
          openAtFirstClick
          inputClassName="!bg-white !h-11 pl-5 pr-3 border border-web-grey-50 tablet:!w-64"
          value={jobTitleValue}
          onChange={handleChangeJobTitle}
          getOptions={(query) =>
            searchCompanyJDJobTitleByQuery(companyId, query)
          }
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          placeholder="全部职位"
          selectOnFocus={false}
          clearValue={true}
          endAdornment={<></>}
        />
        <Select
          size="small"
          className="h-11"
          value={locationValue}
          onChange={handleChangeLocationValue}
          options={locations}
          inputSx={{
            border: '1px solid #dddddd',
            backgroundColor: '#fff!important',
            borderRadius: '8px',
            width: '144px',
          }}
        />
      </div>
      <p className="text-sm   text-web-grey-600">{count} 在招职位</p>
      <div className="grid grid-cols-2 gap-5">
        {jobs.map((job, index) => (
          <JobOpportunityCard data={job} key={index} showContent={true} />
        ))}
      </div>
      {count === 0 && (
        <div className="flex flex-col items-center">
          <p className="text-xl font-semibold">暂无结果</p>
          <p className="text-sm text-web-grey-600 mt-1">
            请尝试更换其他关键词搜索
          </p>
        </div>
      )}
    </div>
  );
};

export default HotJobsTabPanel;
